// #region | Glyphs
// #region | Glyphs Import
import { Animal } from "../Assets/Glyphs/animal";
import { AnimalGroup } from "../Assets/Glyphs/animal_group"
import { AnimalType } from "../Assets/Glyphs/animal_type";
import { Arrow } from "../Assets/Glyphs/arrow";
import { User } from "../Assets/Glyphs/user";
import { ArrowSmooth } from "../Assets/Glyphs/arrowSmooth";
import { Add } from "../Assets/Glyphs/add";
import { AnimalNumber } from "../Assets/Glyphs/animal_number";
import { Attention } from "../Assets/Glyphs/attention";
import { Calibrate } from "../Assets/Glyphs/calibrate";
import { BluePrint } from "../Assets/Glyphs/bluePrint"
import { Check } from "../Assets/Glyphs/check";
import { Condition } from "../Assets/Glyphs/condition";
import { Corner } from "../Assets/Glyphs/corner"
import { Delete } from "../Assets/Glyphs/delete";
import { Edit } from "../Assets/Glyphs/edit";
import { Empty } from "../Assets/Glyphs/empty";
import { Error } from "../Assets/Glyphs/error";
import { Kg } from "../Assets/Glyphs/kg";
import { LifeNumber } from "../Assets/Glyphs/life_number";
import { Location } from "../Assets/Glyphs/location";
import { Mail } from "../Assets/Glyphs/mail";
import { Minus } from "../Assets/Glyphs/minus";
import { AnimalMove } from "../Assets/Glyphs/animal_move";
import { On } from "../Assets/Glyphs/on_off";
import { Off } from "../Assets/Glyphs/on_off";
import { Password } from "../Assets/Glyphs/password";
import { PasswordHide } from "../Assets/Glyphs/password_hide";
import { PasswordShow } from "../Assets/Glyphs/password_show";
import { Phone } from "../Assets/Glyphs/phone";
import { ResponderNumber } from "../Assets/Glyphs/responder_number";
import { Search } from "../Assets/Glyphs/search";
import { Start } from "../Assets/Glyphs/start";
import { Time } from "../Assets/Glyphs/time";
import { TimeToday } from "../Assets/Glyphs/time_today";
import { TimeYesterday } from "../Assets/Glyphs/time_yesterday";
import { Close } from "../Assets/Glyphs/close";
import { Setting } from "../Assets/Glyphs/setting";
import { Stop } from "../Assets/Glyphs/stop";
import { Address } from "../Assets/Glyphs/address";
import { Country } from "../Assets/Glyphs/country";
import { Fetch } from "../Assets/Glyphs/fetch";
import { Clear } from "../Assets/Glyphs/clear";
import { Calendar } from "../Assets/Glyphs/calendar";
import { Percent } from "../Assets/Glyphs/percent";
import { DataParameter } from "../Assets/Glyphs/dataParameter";
import { DataLevel } from "../Assets/Glyphs/dataLevel";
import { FilterParameter } from "../Assets/Glyphs/filterParameter";
import { FeedPlan } from "../Assets/Glyphs/feedPlan";
import { Note } from "../Assets/Glyphs/note";
import { ArrowSmall } from "../Assets/Glyphs/arrowSmall";
import { ArrowReset } from "../Assets/Glyphs/arrowReset";
import { BirthDate } from "../Assets/Glyphs/birthDate";
import { SiteList } from "../Assets/Glyphs/siteList";
import { focus_view } from "../Assets/Glyphs/focusView";
import { Logout } from "../Assets/Glyphs/logout";
import { FullView } from "../Assets/Glyphs/fullView";
import { FeedCorrection } from "../Assets/Glyphs/feedCorrection";
import { FeedCurve } from "../Assets/Glyphs/feedCurve";
import { Energy } from "../Assets/Glyphs/energy";
import { MilestoneDay } from "../Assets/Glyphs/milestone_day";
import { Milestone } from "../Assets/Glyphs/milestone";
import { FarmInfo } from "../Assets/Glyphs/farmInfo";
import { Excel } from "../Assets/Glyphs/excel";
import { Csv } from "../Assets/Glyphs/csv";
import { Upload } from "../Assets/Glyphs/upload";
import { Info } from "../Assets/Glyphs/info";
// #endregion

export const glyphs = {
  Add,
  Address,
  Animal,
  AnimalGroup,
  AnimalMove,
  AnimalNumber,
  AnimalType,
  Arrow,
  ArrowReset,
  ArrowSmall,
  ArrowSmooth,
  Attention,
  BirthDate,
  Calendar,
  Calibrate,
  BluePrint,
  Check,
  Clear,
  Close,
  Condition,
  Country,
  Csv,
  Corner,
  DataLevel,
  DataParameter,
  Delete,
  Edit,
  Empty,
  Energy,
  Error,
  Excel,
  FarmInfo,
  FeedCorrection,
  FeedCurve,
  FeedPlan,
  Fetch,
  FilterParameter,
  focus_view,
FullView,
  Info,
  Kg,
  LifeNumber,
  Location,
  Logout,
  Mail,
  Milestone,
  MilestoneDay,
  Minus,
  Note,
  On,
  Off,
  Password,
  PasswordHide,
  PasswordShow,
  Percent,
  Phone,
  ResponderNumber,
  Search,
  Setting,
  SiteList,
  Start,
  Stop,
  Time,
  TimeToday,
  TimeYesterday,
  Upload,
  User,
};
// #endregion

// #region | Flags
export const flags = {
    en: require("../Assets/Flags/en.png"),
    dk: require("../Assets/Flags/dk.png"),
    de: require("../Assets/Flags/de.png"),
    es: require("../Assets/Flags/es.png"),
    ma: require("../Assets/Flags/ma.png"),
    ko: require("../Assets/Flags/ko.png"),
    nl: require("../Assets/Flags/nl.png")
} as Record<string, any>
// #endregion

// #region | Icons
export const icons = {
    dashboard: require("../Assets/Icons/dashboard.png"),
    kpi: require("../Assets/Icons/kpi-dashboard.png"),
    feedCurves: require("../Assets/Icons/feedCurves.png"),
    silos: require("../Assets/Icons/silos.png"),
    animals: require("../Assets/Icons/animals.png"),
    animalsColor: require("../Assets/Icons/animals_color.png"),
    reports: require("../Assets/Icons/reports.png"),
    logBook: require("../Assets/Icons/logbook.png"),
    globalSettings: require("../Assets/Icons/global-settings.png"),

    platformOperation: require("../Assets/Icons/platform-operation.png"),
    platformDesktop: require("../Assets/Icons/platform-desktop.png"),
    system: require("../Assets/Icons/system.png"),
    system2: require("../Assets/Icons/system2.png"),
    autoPig: require("../Assets/Icons/autopig.png"),
    
    activatorLF: require("../Assets/Icons/activator.png"),
    feederLF: require("../Assets/Icons/location_feeder.png"),
    motorLF: require("../Assets/Icons/motor.png"),
    water: require("../Assets/Icons/water.png"),

    freedaPPT: require("../Assets/Icons/freeda_ppt.png"),
    freedaSorter: require("../Assets/Icons/freeda_sorter.png"),
    freedaLF: require("../Assets/Icons/freeda_lf.png"),
    freedaESF: require("../Assets/Icons/freeda_esf.png"),
    freedaESF_Dynamic: require("../Assets/Icons/freeda_esf_dynamic.png"),
    freedaESF_HeatDetection: require("../Assets/Icons/freeda_esf_heat-detection.png"),
    freedaESF_WalkIn: require("../Assets/Icons/freeda_esf_walk-in.png"),
    freedaESF_WalkThrough: require("../Assets/Icons/freeda_esf_walk-through.png"),
    freedaESF_WeightMonitoring: require("../Assets/Icons/freeda_esf_weight-monitoring.png"),
} 
// #endregion

// #region | Logos
export const logos = {
    whiteAgrisysLogo: require("../Assets/Logos/agrisys_white.png"),
    blackAgrisysLogo: require("../Assets/Logos/agrisys_black.png"),
    whiteFreedaLogo: require("../Assets/Logos/freeda_white_orange.png"),
    greyFreedaLogo: require("../Assets/Logos/freeda_grey_orange.png"),
    freedaSolutions: require("../Assets/Logos/freeda_solutions.png")
}
// #endregion

// #region | Decors
export const decors = {
    def_bg: require("../Assets/Decors/def_bg.png")
}
// #endregion

// #region | Images
export const images = {
    farmstatus: require("../Assets/Img/farm_status.png"),
    totalFeed: require("../Assets/Img/total_feed.png"),
    waterUsage: require("../Assets/Img/water_usage.png"),
    spreading: require("../Assets/Img/spreading.png"),
    autoPig: require("../Assets/Img/autoPig.png"),
    systemView: require("../Assets/Img/systemview.png"),
}
// #endregion

const all = {
    flags: flags,
    icons: icons,
    logos: logos,
    decors: decors,
    images: images,
    glyphs: glyphs
}
export default all